const Yatirimci = resolve => {
    require.ensure(['../views/apps/yatirimci/Yatirimci'], () => {
        resolve(require('../views/apps/yatirimci/Yatirimci.vue'))
    })
};
const YatirimciTanimla = resolve => {
    require.ensure(['../views/apps/yatirimci/YatirimciTanimla'], () => {
        resolve(require('../views/apps/yatirimci/YatirimciTanimla.vue'))
    })
};
const YatirimciListesi = resolve => {
    require.ensure(['../views/apps/yatirimci/YatirimciListesi'], () => {
        resolve(require('../views/apps/yatirimci/YatirimciListesi.vue'))
    })
};
const YatirimciGuncelle = resolve => {
    require.ensure(['../views/apps/yatirimci/YatirimciGuncelle'], () => {
        resolve(require('../views/apps/yatirimci/YatirimciGuncelle.vue'))
    })
};


import layouts from '../layout'
import Vue from 'vue'

Vue.component('yatirimcilistesi', YatirimciListesi);
Vue.component('yatirimcitanimla', YatirimciTanimla);
Vue.component('yatirimciguncelle', YatirimciGuncelle);


export default {
    path: '/yatirimci',
    name: 'yatirimci',
    component: Yatirimci,
    meta: {
        auth: true,
        layout: layouts.navLeft
    },
    children: [{
        path: 'liste',
        name: 'yatirimciListesi',
        component: YatirimciListesi,
        meta: {
            auth: true,
            layout: layouts.navLeft,
            searchable: true,
            tags: ['app']
        }
    }],

}